"use client";

import type { RefObject } from "react";
import { HiiveBannerCarousel } from "@/components/hiives";
import { MEDIA_SOUND_ABOVE_SHEET_CLASS } from "@/components/ui/media-sound-button";
import type { MediaData } from "@/db/schema/hiive";
import { cn } from "@/lib/utils";

interface HiiveHeroSectionProps {
  hiiveName: string;
  bannerMedia: MediaData[];
  isReady: boolean;
  heroRef: RefObject<HTMLDivElement | null>;
  className?: string;
}

export function HiiveHeroSection({
  hiiveName,
  bannerMedia,
  isReady,
  heroRef,
  className,
}: HiiveHeroSectionProps) {
  return (
    <div
      className={cn(
        "relative overflow-hidden transition-opacity duration-150 md:max-h-[60vh]",
        isReady ? "opacity-100" : "opacity-0",
        className,
      )}
      ref={heroRef}
    >
      <HiiveBannerCarousel
        bannerMedia={bannerMedia}
        hiiveName={hiiveName}
        soundButtonClassName={MEDIA_SOUND_ABOVE_SHEET_CLASS}
      />
    </div>
  );
}
